import { LinearProgress } from '@mui/material'

const CustomLoadingOverlay = () => {
  return <LinearProgress sx={{ zIndex: 100 }} />
}

export default CustomLoadingOverlay
